'use strict'

export default function($stateProvider, $urlRouterProvider) {
  'ngInject'

  $urlRouterProvider.when('/myscripts', '/myscripts/list')

  $stateProvider
    .state('myscripts', {
      url: '/myscripts',
      template: require('./myscripts.html'),
      authenticate: true
    })
    .state('myscripts.list', {
      url: '/list',
      template: require('./list/list.html'),
      controller: 'MyScriptsListController',
      controllerAs: 'msListCtrl'
    })
    .state('myscripts.show', {
      url: '/show/:id',
      template: require('./show/show.html'),
      controller: 'MyScriptsShowController',
      controllerAs: 'msShowCtrl'
    })
    .state('myscripts.add', {
      url: '/add',
      template: require('./add/add.html'),
      controller: 'MyScriptsAddController',
      controllerAs: 'msAddCtrl'
    })
    .state('myscripts.edit', {
      url: '/edit/:id',
      template: require('./edit/edit.html'),
      controller: 'MyScriptsEditController',
      controllerAs: 'msEditCtrl'
    })
    .state('myscripts.active', {
      url: '/active',
      template: require('./active/active.html'),
      controller: 'MyScriptsActiveController',
      controllerAs: 'msActiveCtrl'
    })
    .state('myscripts.model', {
      url: '/model',
      template: require('./model/model.html'),
      controller: 'MyScriptsModelController',
      controllerAs: 'msModelCtrl'
    })
    .state('myscripts.addModel', {
      url: '/addModel',
      template: require('./addModel/addModel.html'),
      controller: 'MyScriptsAddModelController',
      controllerAs: 'msAddModelCtrl'
    })
}



// WEBPACK FOOTER //
// ./client/app/myscripts/myscripts.routes.js